import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Paper} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import face_icon3 from "./images/face3.png";
import visitor_pass from "./images/visitor_pass.png";
import { getUserId } from "../Base/helper/baseFunctions";
import history from "../../../history";
import { signOut } from "../SignIn/helper/SigninHelper";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "@mui/icons-material";


const CommonPortal = () => {
  const dispatch = useDispatch();
  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
  );
  const isNewFaceModel = atsModuleData?.find((item) => item.module_name === "New Face Model");
  
  const onOpenAttendance = () => {
    let user_id = btoa(`${getUserId()}=common-portal`);
    if (isNewFaceModel) {
      history.push(`/face-attendance-tracker-new-test/${user_id}`);
    } else {
      history.push(`/face-attendance-tracker-new/${user_id}`);
    }
  };
  const onOpenVisitor = () => {
    history.push(`/visitors-management-common-portal`, "common-portal");
  };
  const handleSignout = () => {
    dispatch({ type: "USER_LOGOUT" });
    signOut();
  };
  //stop user to navigate back from this page
  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === "POP") {
        return false;
      }
    });

    return () => {
      unblock();
    };
  }, []);
  return (
    <Box
      border={1}
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: 6,
        background: "linear-gradient(90deg, #fffaf0 0%, #f7f4ff 100%)",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "10px",
          right: "35px",
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          color: "#000",
          "&:hover": {
            color: "#8b44ff",
          },
        }}
        onClick={handleSignout}
      >
        <Logout
          sx={{
            fontSize: "24px",
          }}
        />
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Sign Out
        </Typography>
      </Box>
   
      <Box
        sx={{
          width: { xs: "94%", md: "85%" },
          maxWidth: 1200,
          textAlign: "center",
          mb: 4,
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 800 }}>
          Welcome to{" "}
          <Box component="span" className="mpl-yellow-color">
            Meepl
          </Box>
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          Please select an option to continue
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 4,
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "stretch",
        }}
      >
        <PortalCard
          title="Employee Attendance"
          subtitle="Mark your attendance using face recognition"
          bgColor="#fff6df"
          icon={face_icon3}
          onClick={onOpenAttendance}
          ctaColor="#fecb03"
        />

        <PortalCard
          title="Visitor Entry"
          subtitle="Check-in or check-out for visitors and guests"
          bgColor="#f3f0ff"
          icon={visitor_pass}
          onClick={onOpenVisitor}
          ctaColor="#000"
        />
      </Box>
    </Box>
  );
};
const PortalCard = ({
  title,
  subtitle,
  bgColor,
  icon,
  onClick,
  ctaColor,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleButtonClick = (e) => {
    setIsAnimating(true);
    onClick();
    setTimeout(() => setIsAnimating(false), 600);
  };
  const isEmp = title === "Employee Attendance";
  return (
    <Paper
      elevation={6}
      sx={{
        width: { xs: "90%", sm: 360 },
        borderRadius: 2,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        background: "#fff",
      }}
    >
      <Box
        sx={{
          p: 4,
          background: bgColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 180,
        }}
      >
        <Box
            component="img"
            src={icon}
            alt="card-icon"
            sx={{
                width: isEmp ? 120 : 280,
                height: isEmp ? 120 : 280,
                marginTop: isEmp ? 0 : 2,
                borderRadius: 2,
                objectFit: "contain",

            }}
        />
      </Box>
      <Box
        sx={{ p: 3, pt: 2, display: "flex", flexDirection: "column", gap: 1 }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            onClick={handleButtonClick}
            endIcon={
              <ArrowForwardIcon
                sx={{
                  animation: isAnimating
                    ? `arrowSlide 0.6s ease-in-out forwards`
                    : "none",
                  "@keyframes arrowSlide": {
                    "0%": {
                      transform: "translateX(-40px)",
                      opacity: 0,
                    },
                    "50%": {
                      opacity: 1,
                    },
                    "100%": {
                      transform: "translateX(0)",
                      opacity: 1,
                    },
                  },
                }}
              />
            }
            sx={{
              width: "100%",
              backgroundColor: ctaColor,
              color: ctaColor === "#fecb03" ? "black" : "#fecb03",
              textTransform: "none",
              fontWeight: 600,
              justifyContent: "space-between",
              paddingRight: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                cursor: "pointer",
                backgroundColor:
                  isEmp ? "#fecb03" : "black",
                boxShadow: "0px 4px 10px rgba(254,203,3, 0.3)",
              },
            }}
          >
            Open
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CommonPortal;
// Employee Face attendance and Visitor Management Entry Common portal
